import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../../../app.service';

@Component({
  selector: 'validation-report-modal',
  templateUrl: './validation-report-modal.component.html',
  styleUrls: ['./validation-report-modal.component.scss']
})
export class ValidationReportModalComponent implements OnInit {

  constructor(public activeModal: NgbActiveModal, private appService: AppService) { }
  public validationReport: any;

  ngOnInit() { 

  }

  showValidationReport(data: any) {

    let output;

    if (data.length == 0) {

      output = 'Sorry, validation report not found.';

    } else {
       
      let report = data[0]; 

      output = 'Validation report for dataset <strong>' + report.fileName + '</strong> submitted by <strong>' + report.memberName + '</strong> on ' + report.creationDate + '<br/>';

      output += 'Overall result: ' + this.formatResult(report.validationResult) + '<br/>'; 

      output += this.getMessages(report.validationMessages, 'Error');
      output += this.getMessages(report.validationMessages, 'Warning'); 

      output += '<br/><strong>Extra Info</strong><br/>';
      output += 'Dataset id: ' + report.datasetId + '<br/>';
      output += 'Workspace Version: ' + report.fmeValidationWorkspaceVersion + '<br/>';
      output += 'FME Version: ' + report.fmeVersion + '<br/>';
      output += 'CustomValidation Version: ' + report.customValidationVersion + '<br/>';

    } 

    this.validationReport = output;
  }

  getMessages(messages: any, type: any) {
    let output = '<br/><strong>' + type + '</strong><br/>'; 
    let validationMessages = messages.filter((s: any) => s.ruleResult != null && s.ruleResult.toLowerCase() == type.toLowerCase());

    if (validationMessages.length == 0) {
      return '';
    }

    for (let i = 0; i < validationMessages.length; i++) {
      output += '- ' + validationMessages[i].ruleMessage + '<br/>';
    }

    return output;
  }

  formatResult(type: any) {
    let color = 'text-success';

    switch (type.toLowerCase()) {
      case 'error':
        color = 'text-danger';
        break;
      case "warning":
        color = 'text-warning';
        break;
    }

    return '<strong><span class="' + color + '">' + type + '</span></strong>';
  }

}
